export const photoCaptureIsSessionExpiredReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isSessionExpired: action.payload });
};
//# sourceMappingURL=photoCaptureIsSessionExpiredReducer.js.map